import { Row } from 'antd';
import React from 'react';
import ZenFormInput from './ZenFormInput';

const ZenFormQuery = ({
    LocalDict,
    modalElements,
    form,
    extraData
}) => {
    const dtArray = ["datePicker", "rangePicker", "dateTimePicker", "timePicker"];
    return (
        <div className={'customer-complaint'} style={{ padding: "10px" }}>
            <div className="customer-form">
                <Row>
                    {
                        modalElements.map((data, index) => {
                            if (dtArray.includes(data["typ"])) {

                                LocalDict[data["data_index"]] = data["format"]
                                    ? data["format"]
                                    : "YYYY-MM-DD hh:mm:ss";
                                LocalDict["data_index_from"] = data["data_index_from"];
                                LocalDict["data_index_to"] = data["data_index_to"];
                            }

                            if (data.visible) {
                                return (
                                    <React.Fragment key={index}>
                                        <ZenFormInput
                                            childType={data.childType}
                                            header={data.header}
                                            footer={data.footer}
                                            labelColSpan={data["labelColSpan"]}
                                            style={data['style']}
                                            height={data['height']}
                                            layoutPosition="space-between"
                                            form={form}
                                            LocalDict={LocalDict}
                                            rows={data.rows}
                                            colSpan={data.colSize || 12}
                                            name={data["data_index"]}
                                            label={data["label"]}
                                            defaultValue={data["default"]}
                                            typ={data["typ"]}
                                            disabled={data["readOnly"]}
                                            source={data["source"]}
                                            sourceParams={data["sourceParams"]}
                                            auxParams={data["auxParams"]}
                                            format={data["format"]}
                                            errorMessage={data["errorMessage"]}
                                            placeHolder={data["placeHolder"]}
                                            required={data["required"]}
                                            options={data["data"]}
                                            from={data["data_index_from"]}
                                            to={data["data_index_to"]}
                                            url={data["url"]}
                                            includeAll={data["includeAll"]}
                                            pname={data["p_data_index"]}
                                            defaultFrom={data["defaultFrom"]}
                                            defaultTo={data["defaultTo"]}
                                            multiSelect={data["multiSelect"]}
                                            searchable={data["isSearchable"]}
                                            data={data}
                                            extraData={extraData}
                                            children={data['children']}
                                        />
                                    </React.Fragment>
                                );
                            }
                        })}
                </Row>
            </div>
        </div>
    )
};

export default ZenFormQuery;